import { Injectable } from "@angular/core";
import { BaseService } from "../base.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class AuthenticationService extends BaseService {
  protected get service(): string {
    return "";
  }

  public login(
    username: string,
    password: string,
    captcha: string,
  ): Observable<any> {
    // console.log(captcha);
    const credentials: Object = {
      username: username,
      password: password,
      recaptcha_token: captcha,
    };
    return super.post<any>(this.service + "bgv/delta/login/", credentials).pipe(
      map((response) => {
        return response.results;
      }),
    );
  }
  public loginPassword(
  body
    
  ): Observable<any> {
    return super
      .post<any>(this.service + "bgv/registration/feature/", body)
      .pipe(
        map((response) => {
          return response.results;
        }),
      );
  }

  public forgotpwd(email: String): Observable<any> {
    const credentials: Object = { email: email, key: "HD2BF6ZFG32QSDFGAJPA" };
    return super
      .patch<any>(this.service + "password/forgot/", credentials)
      .pipe(
        map((response) => {
          return response.results;
        }),
      );
  }

  public resetPwd(
    email: String,
    old_password: String,
    password: String,
    reset_token: any = null,
  ): Observable<any> {
    let credentials: Object = {
      email: email,
      old_password: old_password,
      password: password,
    };
    if (reset_token) {
      credentials["password_reset_token"] = reset_token;
    }
    return super.patch<any>(this.service + "password/reset/", credentials).pipe(
      map((response) => {
        return response.results;
      }),
    );
  }

  public logout(): Observable<any> {
    return super.get<any>(this.service + "zusers/auth/logout/").pipe(
      map((response) => {
        return response.results;
      }),
    );
  }
}
